module.exports = __webpack_public_path__ + "img/vertical_3_5_5010.e645daae.png";